const showFile = (blob, fileName) => {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    const newBlob = new Blob([blob], {type: 'application/pdf'});

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    let link = document.createElement('a');

    link.href = data;
    link.download = `${fileName}.pdf`;
    link.click();
    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
};

export const downloadFile = (url, fileName) => {
    fetch(url)
        .then(r => r.blob())
        .then((blob) => showFile(blob, fileName));
};
